module.exports = __webpack_public_path__ + "r-v3/img/emoti-tears.2357d1e0.svg";